module.exports = __webpack_public_path__ + "static/media/pencil.e7091571.jpg";